import { Injectable } from '@angular/core';

import { Settings } from '../settings';
import { LoadingProvider } from './loading';
import { LogoutProvider } from './logout';
import { Http,Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/timeout';

import { SQLite, SQLiteObject } from '@ionic-native/sqlite';


@Injectable()
export class TeamappProvider {
    apiKey: string = '';

    constructor(public logoutProvider: LogoutProvider, public loadingProvider: LoadingProvider, public http: Http, private sqlite: SQLite) {
        //console.log("Initializing Data Provider");
        this.check_api_token();

    }

    check_api_token() {
        if(Settings.standalone == true) {
            this.apiKey = localStorage.getItem('api_key');
        } else {
            this.apiKey = Settings.teamAppApiToken;
        }
    }

    http_request(data: string, provider: string, cache, loading = true) {
        if(loading == true) {
            this.loadingProvider.show();
        }
        return new Promise(resolve => {
            let userKey: string = localStorage.getItem("app_user");

            let headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');

            let options = new RequestOptions({ headers: headers });
            //console.log(Settings.teamAppApiUrl + '/structure/' + provider + '.php?api_token=' + this.apiKey + '&secret='+userKey+'&' + data);
            this.http.post(Settings.teamAppApiUrl + '/structure/' + provider + '.php','api_token=' + this.apiKey + '&secret='+userKey+'&' + data, options).timeout(20000)
                .subscribe((url_request: any) => {
                    let returnData = url_request.json();
                    if(returnData.requireLogout) {
                        this.logoutProvider.logout();
                    }
                    if(cache === true) {
                        this.sqlite.create({
                            name: 'http_cache.db',
                            location: 'default'
                        })
                            .then((db: SQLiteObject) => {
                                db.executeSql('CREATE TABLE IF NOT EXISTS requests (provider VARCHAR(32), params TEXT, result_string TEXT)', [])
                                    .then(() => {
                                        db.executeSql("SELECT * FROM requests WHERE provider=? AND params=?", [provider, data])
                                            .then((count_result) => {
                                                if (count_result.rows.length > 0) {
                                                    db.executeSql("UPDATE requests SET result_string=? WHERE provider=? AND params=?", [JSON.stringify(returnData), provider, data]).then(() => {
                                                    });
                                                    console.log("UPDATE requests");
                                                } else {
                                                    db.executeSql("INSERT INTO requests (provider, params, result_string) VALUES (?,?,?)", [provider, data, JSON.stringify(returnData)]).then(() => {
                                                    });
                                                    console.log("INSERT requests");

                                                }
                                                if(loading == true) {
                                                    this.loadingProvider.hide();
                                                }
                                                resolve(returnData);
                                            });
                                    })
                                    .catch(e => console.log(e));
                            })
                            .catch(e => console.log(e));
                    } else {
                        if(loading == true) {
                            this.loadingProvider.hide();
                        }
                        resolve(returnData);
                    }

                }, (errorResponse: any) => {
                    console.log('error');
                    console.log(errorResponse.name);
                    if (errorResponse.name === 'TimeoutError') {
                        if (cache === true) {
                            this.sqlite.create({
                                name: 'http_cache.db',
                                location: 'default'
                            })
                                .then((db: SQLiteObject) => {
                                    db.executeSql('CREATE TABLE IF NOT EXISTS requests (provider VARCHAR(32), params TEXT, result_string TEXT)', [])
                                        .then(() => {
                                            db.executeSql("SELECT * FROM requests WHERE provider=? AND params=?", [provider, data])
                                                .then((count_result) => {
                                                    if (count_result.rows.length > 0) {
                                                        if(loading == true) {
                                                            this.loadingProvider.hide();
                                                        }
                                                        resolve(JSON.parse(count_result.rows.item(0).result_string));
                                                    } else {
                                                        if(loading == true) {
                                                            this.loadingProvider.hide();
                                                        } //Error Needed
                                                        console.log("No Cache");
                                                    }

                                                });
                                        })
                                        .catch(e => console.log(e));
                                })
                                .catch(e => console.log(e));
                        } else {
                            if(loading == true) {
                                this.loadingProvider.hide();
                            }
                            console.log("// no cache - browser provided");
                        }

                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/teamapp.ts